import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickHistory from '@/components/brick_history.vue'

let infos = new BrickInfos()

infos.back_classes = ['fas', 'fa-square', 'text-green']
infos.front_classes = ['fas', 'fa-clock', 'text-white']
infos.name = 'history'
infos.associated_class_name = 'AutomlHistoryTable'
infos.editing_component_name = 'BrickHistory'
infos.editing_component = BrickHistory
infos.descriptions = {
	en: {
		short_tooltip_description: 'History',
		full_tooltip_description:
			'Automatic creation of history columns for a table',
		navbar_name: 'History',
	},
	fr: {
		short_tooltip_description: 'Historique',
		full_tooltip_description:
			"Création automatique des colonnes d'historique d'une table",
		navbar_name: 'Historique',
	},
}
// infos.short_tooltip_description = 'history_short_tooltip'
// infos.full_tooltip_description = 'history_full_tooltip'
// infos.navbar_name = 'history_navbar'
infos.background_color = 'green'

brick_registerer(infos)
